import { Box, Typography } from '@mui/material'
import { withNavbar } from '../../app/layout/HOC'

function TermsAndCondition() {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: '120px', p:4 }}>
            <Typography variant='h4'>Privacy Policy</Typography>
            <Box component='p'>
                Protecting your data is something we take seriously. In our daily operations of our company we treat personal data and have therefore adopted this privacy policy that tells you how we treat your data.
            </Box>
            <Box component='p'>
                Tier1 Asset A/S, Hejrevang 18, DK-3450 Allerød, Comp.Reg.No. DK-26031486 are data administrators for the information we collect about you and we ensure that your personal information is processed in accordance with the law.
            </Box>
            <Box component='p'>
                If you would like to contact us regarding our processing of personal information, you can do it at <a href='mailto:marketing@tier1asset.com'>marketing@tier1asset.com</a> or <a href='mailto:mlp@tier1asset.com'>mlp@tier1asset.com</a>.
            </Box>
            <Typography variant='h6'>Processing of personal data</Typography>
            <Box component='p'>
                Personal information is any kind of information that may be attributed to you to some extent. When using our website, we collect and process a variety of such information. This happens for example by common access content if you sign up for our newsletter, participate in competitions or surveys, register yourself as a user or subscriber, otherwise use of services or make purchases through the website.
            </Box>
            <Box component='p'>
                We typically collect and process the following types of information: A unique ID and technical information about your computer, tablet or mobile phone, your IP number, geographic location, and which pages you click (interests).
            </Box>
            <Box component='p'>
                Normally, in our daily work, we will collect the personal data you provide in connection with Customer- or Supplier Application.
            </Box>
            <Box component='p'>
                To the extent that you give explicit consent, we may process other personal data. This will typically be associated with the creation of login, purchase, sign-up for an online service or newsletter.
            </Box>
            <Typography variant='h6'>Security</Typography>
            <Box component='p'>
                We have taken appropriate technical and organizational measures against the fact that your information is accidentally or illegally deleted, published, lost, impaired, or comes to the knowledge of a person, misused, or otherwise treated in violation of the law.
            </Box>
            <Typography variant='h6'>Purpose</Typography>
            <Box component='p'>
                The information is used to identify you as a user and show you the ads that are most likely to be relevant to you, to register your purchases and payments, and to provide the services you have requested, such as. to send a newsletter.
            </Box>
            <Box component='p'>
                In addition, we use the information to optimize our services and content.
            </Box>
            <Typography variant='h6'>Data minimization</Typography>
            <Box component='p'>
                We collect, process and store only the personal data needed to meet our intended purpose. Additionally, it may be decided by law what type of data is required to collect and store for our business operations. The type and extent of the personal data we process may also be required to fulfill a contract or other legal obligation.
            </Box>
            <Typography variant='h6'>Data is kept up to date</Typography>
            <Box component='p'>
                As our service is dependent on your data being accurate and up to date, please inform us about relevant changes to your data. You can use the contact details above to notify us of your changes, so make sure to update your personal data.
            </Box>
            <Box component='p'>
                If we become aware that data is incorrect, we update the information and notify you.
            </Box>
            <Typography variant='h6'>Period of storage</Typography>
            <Box component='p'>
                The information is kept for the time allowed by law and we delete them when they are no longer necessary. The period depends on the nature of the information and the background for storage.
            </Box>
            <Box component='p'>
                Therefore, it is not possible to specify a general timeframe for when information is deleted.
            </Box>
            <Typography variant='h6'>Consent</Typography>
            <Box component='p'>
                Your consent for receiving, for example, Newsletter is optional, and you can withdraw it at any time by contacting us. Use the contact information above for more information.
            </Box>
            <Typography variant='h6'>Disclosure of information</Typography>
            <Box component='p'>
                Disclosure of personal information such as name and e-mail, etc. will only happen if you consent to it.
            </Box>
            <Typography variant='h6'>Your rights</Typography>
            <Box component='p'>
                You are entitled at any time to know what data we treat about you, where they originate and what we apply them to.
            </Box>
            <Box component='p'>
                You can also find out how long we keep your personal data and who receives data about you, to the extent that we pass data in Denmark and abroad.
            </Box>
            <Box component='p'>
                If you request, we can inform you about the data we process for you. Access may, however, be limited for the protection of other people’s privacy, business secrets and intellectual property rights.
            </Box>
            <Box component='p'>
                You can make use of your rights by contacting us. You can find our contact information at the top. If you believe that the personal data we treat about you is inaccurate, you are entitled to correct them. You must contact us and indicate what the inaccuracies are and how they can be corrected.
            </Box>
            <Box component='p'>
                In some cases, we will have an obligation to delete your personal data. This applies, for example, if you withdraw any given consent. If you believe your data is no longer necessary for the purpose we obtained them, you may want to have them deleted. You can also contact us if you believe your personal data is being processed in violation of the law or other legal obligations.
            </Box>
            <Box component='p'>
                You also have the opportunity to file a complaint with the Data Inspectorate – but we will also cooperate and make you feel safe about our processing of your personal data.
            </Box>
            <Box component='p'>
                When you address a request to correct or delete your personal data, we will investigate whether the conditions are met and, in that case, make changes or deletions as soon as possible.
            </Box>
            <Box component='p'>
                You are entitled to object to our processing of your personal data. You may also object to our disclosure of your data for marketing purposes. You can use the contact information at the top to send an objection. If your opposition is justified, we will stop processing your personal data.
            </Box>
            <Box component='p'>
                You have the opportunity to avail yourself of data portability, in which case you wish your information moved to another data controller or data processor.
            </Box>
            <Box component='p'>
                We will delete your personal data when they are no longer required for the purpose for which they are collected.
            </Box>
        </Box>
    )
}

const TermsAndConditions = withNavbar(TermsAndCondition);

export default TermsAndConditions;